import React from 'react';
import { motion } from 'framer-motion';
import { LockIcon } from 'lucide-react';
export function PricingSection() {
  return <section id="pricing" className="bg-navy py-20 px-4" data-id="element-106">
      <div className="max-w-4xl mx-auto" data-id="element-107">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="bg-white p-1 md:p-2 shadow-2xl" data-id="element-108">
          {/* Inner border to look like an official document */}
          <div className="border-2 border-navy p-6 md:p-10 bg-white relative" data-id="element-109">
            {/* Document Header */}
            <div className="flex flex-col md:flex-row justify-between items-start md:items-end border-b-2 border-navy pb-6 mb-8" data-id="element-110">
              <div data-id="element-111">
                <h2 className="font-heading font-bold text-3xl text-navy uppercase tracking-wide" data-id="element-112">
                  Requisition Form
                </h2>
                <p className="font-heading text-sm text-gray-500 uppercase tracking-widest mt-1" data-id="element-113">
                  Dept. of Family Preparedness
                </p>
              </div>
              <div className="mt-4 md:mt-0 text-left md:text-right" data-id="element-114">
                <p className="font-heading text-xs text-gray-500 uppercase tracking-widest" data-id="element-115">
                  Date: {new Date().toLocaleDateString()}
                </p>
                <p className="font-heading text-xs text-gray-500 uppercase tracking-widest mt-1" data-id="element-116">
                  Status:{' '}
                  <span className="text-safety-red font-bold" data-id="element-117">URGENT</span>
                </p>
              </div>
            </div>

            {/* Line Items */}
            <div className="space-y-4 mb-8" data-id="element-118">
              <div className="flex justify-between items-center py-2 border-b border-gray-200" data-id="element-119">
                <div className="flex items-center gap-3" data-id="element-120">
                  <img src="https://cdn.magicpatterns.com/uploads/8ubZM7iCuRTeiHqk2DCMyn/Prod._2.png" alt="72-Hour Emergency Binder" className="w-10 h-10 object-contain rounded flex-shrink-0" data-id="element-121" />
                  <span className="font-heading font-bold text-navy text-lg" data-id="element-122">
                    72-Hour Emergency Binder
                  </span>
                </div>
                <span className="font-heading text-gray-600" data-id="element-123">$47.00</span>
              </div>
              <div className="flex justify-between items-center py-2 border-b border-gray-200" data-id="element-124">
                <div className="flex items-center gap-3" data-id="element-125">
                  <img src="https://cdn.magicpatterns.com/uploads/h4S9Udm8Xa8cRFW2ren1sr/MockUp_1.png" alt="24-Hour Blackout Guide" className="w-10 h-10 object-contain rounded flex-shrink-0" data-id="element-126" />
                  <span className="font-heading text-gray-700" data-id="element-127">
                    Bonus 1: 24-Hour Blackout Guide
                  </span>
                </div>
                <span className="font-heading text-gray-600" data-id="element-128">$27.00</span>
              </div>
              <div className="flex justify-between items-center py-2 border-b border-gray-200" data-id="element-129">
                <div className="flex items-center gap-3" data-id="element-130">
                  <img src="https://cdn.magicpatterns.com/uploads/nSMbjZN34LLyR6R4nWkXJR/MockUp_2.png" alt="Emergency Gear Master List" className="w-10 h-10 object-contain rounded flex-shrink-0" data-id="element-131" />
                  <span className="font-heading text-gray-700" data-id="element-132">
                    Bonus 2: Emergency Gear Master List
                  </span>
                </div>
                <span className="font-heading text-gray-600" data-id="element-133">$17.00</span>
              </div>
              <div className="flex justify-between items-center py-2 border-b border-gray-200" data-id="element-134">
                <div className="flex items-center gap-3" data-id="element-135">
                  <img src="https://cdn.magicpatterns.com/uploads/eqcAFcrCNB4XmGm5JJAHh8/MockUp_3.png" alt="Car Go-Bag Master Plan" className="w-10 h-10 object-contain rounded flex-shrink-0" data-id="element-136" />
                  <span className="font-heading text-gray-700" data-id="element-137">
                    Bonus 3: Car Go-Bag Master Plan
                  </span>
                </div>
                <span className="font-heading text-gray-600" data-id="element-138">$19.00</span>
              </div>
            </div>

            {/* Total Section */}
            <div className="bg-light-gray p-6 border border-gray-300 mb-8 relative overflow-hidden" data-id="element-139">
              {/* Premium discount badge */}
              <div className="flex justify-center mb-4 md:mb-0 md:absolute md:-top-3 md:left-1/2 md:-translate-x-1/2 md:z-10" data-id="element-140">
                <div className="relative bg-gradient-to-r from-yellow-600 via-yellow-400 to-yellow-600 text-yellow-950 font-heading font-bold text-sm px-5 py-2.5 uppercase tracking-widest shadow-lg border border-yellow-500/50 flex rounded-md md:rounded-b-md pt-[30px] pb-[30px] gap-[8px] items-center justify-center pl-[80px] pr-[80px]" data-id="element-141">
                  <span className="text-yellow-900/80 text-xs" data-id="element-142">★</span>
                  <span className="font-extrabold text-yellow-950 drop-shadow-[0_1px_2px_rgba(0,0,0,0.3)] text-[24px]" style={{
                  WebkitTextStroke: '0.5px rgba(0,0,0,0.15)'
                }} data-id="element-143">
                    94% OFF
                  </span>
                  <span className="text-yellow-900/80 text-xs" data-id="element-144">★</span>
                  <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/25 to-transparent animate-shimmer rounded-md md:rounded-b-md" data-id="element-145" />
                </div>
              </div>

              <div className="flex flex-col md:flex-row justify-between items-center" data-id="element-146">
                <div className="text-left mb-4 md:mb-0" data-id="element-147">
                  <p className="font-heading text-sm text-gray-500 uppercase tracking-widest mb-1" data-id="element-148">
                    Total Value
                  </p>
                  <p className="font-heading text-2xl text-gray-400 line-through decoration-safety-red decoration-2" data-id="element-149">
                    $110.00+
                  </p>
                </div>

                <div className="flex flex-col items-center mt-6 w-full md:w-auto text-center" data-id="element-150">
                  <p className="font-heading text-sm text-safety-red font-bold uppercase tracking-widest" data-id="element-151">
                    You Save $103.61
                  </p>
                </div>

                <div className="text-center md:text-right mt-4 md:mt-0" data-id="element-152">
                  <p className="font-heading text-safety-red font-bold uppercase tracking-widest mb-1 text-[16px]" data-id="element-153">
                    Your Authorized
                    <br data-id="element-154" />
                    Price Today
                  </p>
                  <a href="https://www.myreadysystem.com/checkouts/cn/hWNA2SY4OSxb4AwEvUj31SCX/en-us?_r=AQABNXDEndDwqLIdnM1TG_dBl708E27Yq2k2Lhij34QVXJQ&auto_redirect=false&edge_redirect=true&preview_theme_id=138595008574&skip_shop_pay=true" target="_blank" rel="noopener noreferrer" onClick={() => {
                  if (typeof (window as any).fbq === 'function') (window as any).fbq('track', 'AddToCart');
                }} className="inline-block font-heading text-4xl md:text-5xl font-bold text-white bg-cta-green hover:bg-green-700 transition-colors px-8 py-3 rounded-sm shadow-lg border border-green-800 cursor-pointer mt-1" data-id="element-155">
                    $6.39
                  </a>
                </div>
              </div>
            </div>

            <div className="text-center" data-id="element-156">
              <p className="font-heading text-navy font-bold uppercase tracking-wide mb-4" data-id="element-157">
                Complete Emergency Preparedness Package
              </p>
              <a href="https://www.myreadysystem.com/checkouts/cn/hWNA2SY4OSxb4AwEvUj31SCX/en-us?_r=AQABNXDEndDwqLIdnM1TG_dBl708E27Yq2k2Lhij34QVXJQ&auto_redirect=false&edge_redirect=true&preview_theme_id=138595008574&skip_shop_pay=true" target="_blank" rel="noopener noreferrer" onClick={() => {
              if (typeof (window as any).fbq === 'function') (window as any).fbq('track', 'AddToCart');
            }} className="w-full bg-cta-green hover:bg-green-700 text-white font-heading font-bold text-xl py-5 px-8 rounded-sm transition-colors shadow-lg border border-green-800 uppercase tracking-wide flex items-center justify-center" data-id="element-158">
                <LockIcon className="w-5 h-5 mr-2" data-id="element-159" />
                Get The E-Book For $6.39
              </a>
              <p className="font-heading text-xs text-gray-500 uppercase tracking-widest mt-4" data-id="element-160">
                Secure 256-Bit Encrypted Checkout
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}